
// LIVE
let BLOCKCHAIN_HOST = "https://main.codenotary.io";
let FOUNDATION_HOST = "https://api.codenotary.io/foundation/v1";
let SENTRY_DSN = "https://48e652c42c0741efa4b294f9e3ac8e86@sentry.io/1799412";

const BLOCKCHAIN_ASSET_ADDRESS = "0x3222c50e1917c3551c7b6ee10d8e1bb00b84062b";
const BLOCKCHAIN_ORG_ADDRESS = "0x258e39ff07e6e3a2430aa951f387cfbd808835bc";

// DEV
const BLOCKCHAIN_HOST_STAGING = "https://main.staging.codenotary.io";
const BLOCKCHAIN_ASSET_ADDRESS_STAGING =
  "0x05ce69454a13c8ac0bd20fdc48b09068f5c0a5ed";
const BLOCKCHAIN_ORG_ADDRESS_STAGING =
  "0x4a9a0547949ec55ecbf06738e8c2bad747f410bb";
const FOUNDATION_HOST_STAGING =
  "https://api.staging.codenotary.io/foundation/v1";

const { API_URL, BLOCKCHAIN_URL } = window.CODENOTARY_ENV || {};

if (API_URL && BLOCKCHAIN_URL) {
  BLOCKCHAIN_HOST = BLOCKCHAIN_URL;
  FOUNDATION_HOST = API_URL;
  SENTRY_DSN = undefined;
}

export {
  BLOCKCHAIN_HOST,
  BLOCKCHAIN_HOST_STAGING,
  SENTRY_DSN,
  FOUNDATION_HOST,
  FOUNDATION_HOST_STAGING,
  BLOCKCHAIN_ASSET_ADDRESS,
  BLOCKCHAIN_ASSET_ADDRESS_STAGING,
  BLOCKCHAIN_ORG_ADDRESS,
  BLOCKCHAIN_ORG_ADDRESS_STAGING
};
